module.exports = __webpack_public_path__ + "img/岱高.png";